import { MarketplaceAnalyticsContext } from '@atlassian/mpac-analytics';
import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';

import BaseRouteHandler from '../common/routeHandlers/BaseRouteHandler';

const AdminPageCodeSplit = lazyForPaint(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "chunk-admin" */ './AdminPageRouteProcessor'
  ).then((module) => module.default)
);

const RouteHandler = (props) => {
  return (
    <BaseRouteHandler scrollToTopOnPathChange includePartnerQuickLinks>
      <MarketplaceAnalyticsContext properties={{ source: 'adminScreen' }}>
        <LazySuspense fallback={<div />}>
          <AdminPageCodeSplit {...props} />
        </LazySuspense>
      </MarketplaceAnalyticsContext>
    </BaseRouteHandler>
  );
};

export default RouteHandler;
